import {
    CreateCustomerGuidRequest,
    CustomerGuidFields,
    ICustomerGuid,
    UpdateCustomerGuidRequest,
} from '@mybake/ui/models/Customers/ICustomerGuid';

const fields = (customer: CustomerGuidFields): CustomerGuidFields => ({
    firstName: customer.firstName,
    lastName: customer.lastName,
    email: customer.email,
    phoneNumber: customer.phoneNumber,
    instagram: customer.instagram,
    faceBook: customer.faceBook,
});

export const toCreateCustomerGuidRequest = (customer: CustomerGuidFields): CreateCustomerGuidRequest => fields(customer);

export const toUpdateCustomerGuidRequest = (customer: ICustomerGuid): UpdateCustomerGuidRequest => ({
    id: customer.id ?? undefined,
    ...fields(customer),
});
